import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    if (!this.button) return
    this.setupTimer = setTimeout(() => this.configure(), 0) // button may not exist yet during parse
  }

  disconnect() {
    clearTimeout(this.setupTimer)
    const form = this.listeningForm
    if (!form) return
    form.removeEventListener("submit", this.toSpinner)
    form.removeEventListener("turbo:submit-start", this.toSpinner)
    form.removeEventListener("turbo:submit-end", this.toButton)
    form.removeEventListener("spinner:to-spinner", this.toSpinner)
    form.removeEventListener("spinner:to-button", this.toButton)
  }

  configure() {
    if (!this.button) return
    this.buttonOriginalHTML = this.button.innerHTML
    this.buttonOriginalAriaLabel = this.button.getAttribute("aria-label")
    this.buttonSpinnerHTML = `<svg data-controller="spinner" class="h-3/4 m-auto" aria-hidden="true" />`
    this.listeningForm = this.form
    this.listeningForm.addEventListener("submit", this.toSpinner)
    this.listeningForm.addEventListener("turbo:submit-start", this.toSpinner)
    this.listeningForm.addEventListener("turbo:submit-end", this.toButton)
    this.listeningForm.addEventListener("spinner:to-spinner", this.toSpinner)
    this.listeningForm.addEventListener("spinner:to-button", this.toButton)
  }

  toSpinner = () => {
    if (!this.button || this.button.getAttribute("aria-busy") === "true") return
    this.lockButtonSize()
    this.wasDisabled = this.button.disabled
    this.retainAccessibleName()
    this.button.disabled = true
    this.button.setAttribute("aria-busy", "true")
    this.button.innerHTML = this.buttonSpinnerHTML
  }

  toButton = () => {
    if (!this.button) return
    this.button.innerHTML = this.buttonOriginalHTML
    this.button.disabled = this.wasDisabled === true
    this.button.removeAttribute("aria-busy")
    this.restoreAccessibleName()
    this.unlockButtonSize()
  }

  retainAccessibleName() {
    if (this.buttonOriginalAriaLabel) return

    const name = this.button.innerText?.trim() || this.button.value || "Submitting"
    this.button.setAttribute("aria-label", name)
  }

  restoreAccessibleName() {
    if (this.buttonOriginalAriaLabel) {
      this.button.setAttribute("aria-label", this.buttonOriginalAriaLabel)
    } else {
      this.button.removeAttribute("aria-label")
    }
  }

  lockButtonSize() {
    const rect = this.button.getBoundingClientRect()
    this.button.style.width = `${Math.ceil(rect.width)}px`
    this.button.style.height = `${Math.ceil(rect.height)}px`
  }

  unlockButtonSize() {
    this.button.style.width = ""
    this.button.style.height = ""
  }

  get form() {
    if (this.element.tagName === "FORM")
      return this.element
    else
      return this.element.closest("form")
  }

  get button() {
    if (this.element.type === "submit")
      return this.element
    else
      return this.element.querySelector("button[type=submit]")
  }
}
